import PropTypes from 'prop-types';
import cn from 'classnames';

import StarIcon from 'assets/icons/StarIcon';
import LoadingIcon from 'assets/icons/LoadingIcon';

const ButtonStar = ({ onChange, active, options, value, isLoading, label }) => {
  return (
    <div className="group flex items-center justify-center p-1 relative">
      {label && <p className="font-normal text-sm font-SofiaPro mr-1">{label}</p>}

      {isLoading ? (
        <LoadingIcon className="h-3.5 w-3.5 flex-none animate-spin text-yellow-bright self-center" />
      ) : (
        <>
          <StarIcon
            className={cn('transition h-3.5 w-3.5 pointer-events-none', {
              ['text-yellow-bright']: active,
              ['text-gray-250 group-hover:text-gray-400']: !active,
            })}
          />

          <select
            value={value}
            className="absolute cursor-pointer text-transparent inset-0 bg-transparent appearance-none focus:outline-none focus:border-transparent"
            onChange={onChange}
          >
            <option value="">(Вне списка)</option>
            {options.map(({ id, name }) => (
              <option key={id} value={id}>
                {name}
              </option>
            ))}
          </select>
        </>
      )}
    </div>
  );
};

ButtonStar.propTypes = {
  onChange: PropTypes.func.isRequired,
  active: PropTypes.bool,
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
export default ButtonStar;
